import { SxProp, View } from 'dripsy';
import React from 'react';

export interface DividerProps {
  height?: number;
  width?: number;
  sx?: SxProp;
  vertical?: boolean;
  horizontal?: boolean;
}

export const Divider: React.FC<DividerProps> = (props) => {
  const { height, width, sx } = props;

  const baseStyle = {
    backgroundColor: '$borderDivider',
    ...sx
  };

  const vertical = {
    ...baseStyle,
    height: '100%',
    width: 1
  };

  const horizontal = {
    ...baseStyle,
    height: height || 1,
    width: width || '100%'
  };

  const styles = props.vertical ? vertical : horizontal;

  return <View sx={styles} />;
};
